export default {
  data() {
    return {
      loading: true,
    };
  },
  created() {
    this.loadData();
  },
  props: {
    active: Boolean,
  },
  methods: {
    loadData() {
      if(!this.active) {
        this.loading = true;
      } else {
        this.loading = true;
        setTimeout(() => {
          this.loading = false;
        }, 200);
      }
    },
  },
  watch: {
    active() {
      this.loadData();
    },
  },
}
